import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
    deleteTax,
    getPaginatedTaxes
} from '@/modules/dataWrangler/dataWrangler';
import { DeleteIcon } from '@/resources/icons';
import { openDrawer } from '@/state/actions';
import { useToastNotification, useUrlParams } from '@/hooks';

import WarnConfirmDialog from '../../WarnConfirmDialog';
import ActionIconWrapper from '../ActionIconWrapper';

/**
 * Edit Icon for Tax with dispatch attached
 * @param {string} id ID of the tax to edit.
 */
export const EditTaxIcon = ({ id }) => {
    const dispatch = useDispatch();

    const currentTax = useSelector((state) =>
        state.user?.activeBusiness?.taxes?.find(
            (element) => element.taxId === id
        )
    );

    const handleClick = () => {
        if (currentTax) {
            dispatch(
                openDrawer({
                    id: 'tax',
                    tax: currentTax,
                    edit: true
                })
            );
        }
    };

    return (
        <ActionIconWrapper
            action="edit"
            label="Edit"
            onClick={handleClick}
            tooltip="Edit Tax"
        />
    );
};

EditTaxIcon.propTypes = {
    id: PropTypes.string.isRequired
};

/**
 * Delete Icon for Tax with dispatch attached
 * @param {string} id ID of the tax to delete.
 */
export const DeleteTaxIcon = ({ id, tax }) => {
    const [dialogActive, setDialogAction] = useState(false);
    const { triggerToast } = useToastNotification();
    const { getUrlParams } = useUrlParams();

    const handleClick = () => {
        setDialogAction(true);
    };

    const handleConfirmation = async () => {
        const currentUrlParams = getUrlParams();
        setDialogAction(false);
        await deleteTax(id);
        getPaginatedTaxes(currentUrlParams);
        triggerToast({
            message: `Tax "${tax}" Deleted `,
            action: 'delete',
            icon: <DeleteIcon />
        });
    };

    const handleCancellation = () => {
        setDialogAction(false);
    };

    return (
        <>
            <ActionIconWrapper
                action="delete"
                label="Delete"
                onClick={() => {
                    handleClick();
                }}
                tooltip="Delete Tax"
            />
            <WarnConfirmDialog
                onCancel={() => handleCancellation()}
                onConfirm={() => handleConfirmation()}
                message={`Are you sure you want to delete "${tax}"?`}
                cancelText="Cancel"
                confirmText="Delete Tax"
                open={dialogActive}
            />
        </>
    );
};

DeleteTaxIcon.propTypes = {
    id: PropTypes.string.isRequired,
    tax: PropTypes.string.isRequired
};
